import { Component, OnChanges, Input } from '@angular/core';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import {NewLanguageService} from '../../dataservices/new-language/new-language.service';
import { UserStoryService } from 'src/app/dataservices/userStory/user-story.service';
import { ImageGroupService } from 'src/app/dataservices/master-service/image-group.service';
/**
 * Constant from the file
 */
import { ACTION_ON, ACTION_TYPE, CALLING_FROM, CTA_TYPE, NUMBERS, PRODUCT_TYPE_CONSTANT_NAME, PRODUCT_TYPE_NUMBER_MAPPING, STORY_TYPES } from '../../constants/app.constants';
import { CHANNEL_USER_CARD } from '../../constants/data-testId.constants';

/**
 * import interface
 */
 import { ECProductFeed } from '../../../app/interface/editors-choice/editors-choice.model';
import { DataStorageService } from 'src/app/dataservices/data-storage.service';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { CLICK, CLICK_SUB } from 'analytics2.0/dist/core/constants/analytic.interface';


@Component({
  selector: 'app-channel-user-card',
  templateUrl: './channel-user-card.component.html',
  styleUrls: ['./channel-user-card.component.scss']
})
export class ChannelUserCardComponent implements OnChanges {
@Input() usercardsize;
@Input() data;
@Input() callingFrom;
@Input() removechannelfollow;

@Input() screenName: string;

@Input() productType: number;
@Input() productTypeId: number;

  /**
   * tracks whether part of EC post or not
   */
  @Input() ecProductFeed?: ECProductFeed;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subscribe_obj: any;
  showSubscribeModal = false;

  /**
   * Data test id for the channel user card.
   */
  public dataTestId = CHANNEL_USER_CARD;

  /**
   * Minimum title length
   */
  public channelLength = NUMBERS.FOURTY_TWO;

public isStoryAvailable: number; 

  constructor(public fcs:FunCollectionService,
    public mls:NewLanguageService,
    public dss: DataStorageService,
    public storyServ: UserStoryService,
    public igs: ImageGroupService,
    private analyticSdk: Analytics
    ) { }

  ngOnInit() {
    this.isStoryAvailable = this.data.is_story_available;
  }

  ngOnChanges(): void {
    this.subscribe_obj = {
      'target_id': this.data.channel_id, 'channel_name': this.data.title,
      'tnc_url': this.data.tnc_url, 'target_name': this.data.powered_name, 'publication_logo': this.data.channel_logo, 'target_label': this.data.powered_by_label,
      'sponsor_footer_text': this.data.sponsor_footer_text,
      'no_of_members': this.data.no_of_members,
      'safe_url': this.data.safe_url,
      'product_view': 1
    };

  }

  backClicked(): void {
    this.showSubscribeModal = false;
  }

  followChannel(): void {
    const data: CLICK_SUB = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.CHANNEL,
      entity_code: this.data.channel_id,
      sub_entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.productType],
      sub_entity_code: this.productTypeId,
      current_screen_name: this.fcs.currentScreename,
      action_on: ACTION_ON.FOLLOW_CHANNEL,
      action_type: ACTION_TYPE.CLICK,
      cta_type: CTA_TYPE.BUTTON,
      start_time: new Date().getTime(),
      rank: null
    };
    this.analyticSdk.analyticService.CLICK_SUB(data);
    this.showSubscribeModal = true;
  }

  hasSubscribed(data): void {
    if (data == true) {
      this.data.is_subscribed = 1;
    }
  }
  /**
   * 
   * @param story function to check if all stories are viewed
   * @returns 
   */
  isStoriesAvailable(channelId): boolean {
    const apiRes = this.isStoryAvailable === 1 ? true : false;
    let realTime = false;
    const key = 'channel' + channelId;
    realTime = !this.storyServ.isAllStoryViewed(key);
    return apiRes && realTime;
  }
  /**
   * show user story unavailable
   */
  showStory(uuid): void {
    this.dss.viewStoryThroughProfileUuid = uuid;
    this.dss.userType = 'PHARMA';
     this.dss.storyProfileChannelId = this.data.channel_id;
    this.dss.showStoryThroughProfile.next(true);
  }

  navigateToChannelDetail(): void{ 
    if (this.isStoriesAvailable(this.data.channel_id)) {
      this.showStory(this.data.safe_url);
    }
    else {
      this.fcs.navigateToChannelDetail(this.data.channel_id);
    }
  }
  /**
   * profile picture clicked
   */
  profilePicClicked(): void {
    const clickSub: CLICK_SUB = {
    entity_type: PRODUCT_TYPE_CONSTANT_NAME.CHANNEL,
    entity_code: this.data.channel_id,
    sub_entity_type: PRODUCT_TYPE_NUMBER_MAPPING[this.productType],
    sub_entity_code: this.productTypeId,
    current_screen_name: this.fcs.currentScreename,
    action_on: ACTION_ON.CHANNEL_NAME,
    action_type: ACTION_TYPE.CLICK,
    cta_type: CTA_TYPE.CARD,
    start_time: new Date().getTime(),
    rank: 0
    }
    this.analyticSdk.analyticService.CLICK_SUB(clickSub);
    this.navigateToChannelDetail();
  }

  /**
   * shows title when clicked on icon
   * @param event
   * @returns boolean
   */
  showTitle(event): boolean {
    event.stopPropagation();
    return false;
  }

  /**
   * checks if EC badge need to be shown
   * @returns
   */
  get showECHeader(): boolean {
    return (this.callingFrom === CALLING_FROM.FEED_DETAIL ||
      this.callingFrom !== CALLING_FROM.SEARCH_FEED_CARD) &&
      this.ecProductFeed && this.ecProductFeed.isEcProduct;
  }

  /**
   *
   * Checks if the channel title has less than specified characters
   * @readonly
   * @type {boolean}
   * @memberof ChannelUserCardComponent
   */
  get eCHeader(): boolean {
    return this.data && this.data.title && this.data.title.length < NUMBERS.TWENTY_THREE;
  }
}
